import { BASE_URL, BASE_URL_API } from "../../../constants";
import fetcher from "../../../utils/fetcher";
import { useStepper } from "../stores";

export const _api_delete_employee = ({ id_user }) => {
    const url = `${BASE_URL_API}/onboarding/user/delete/${id_user}`;
    return fetcher(url, {
        method: "DELETE",
        credentials: "include",
    });
};

export const _api_get_status_by_company = () => {
    const url = `${BASE_URL_API}/contract-status-by-company`;
    return fetcher(url, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_dcs_job_types = () => {
    const url = `${BASE_URL}/api/dcs_job_types/list`;
    return fetcher(url, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_seller_dcs = () => {
    const url = `${BASE_URL}/api/dcs_sellers/list`;
    return fetcher(url, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_user_onboarding = ({ id_pending_user }) => {
    const url = `${BASE_URL_API}/onboarding/user/create/${id_pending_user}`;
    return fetcher(url, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_model = (type = null) => {
    const url = `${BASE_URL_API}/task/task_definition/list${
        type ? "?type=" + type : ""
    }`;
    return fetcher(url, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_post_task_definition = ({ ids }) => {
    const { id_user } = useStepper.getState().step_personal_informations;
    const url = BASE_URL_API + "/task/task_definition/list/" + id_user;
    return fetcher(url, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
            ids,
        }),
    });
};

export const _api_save_step_contract = (data) => {
    const { email, id_user } = useStepper.getState().step_personal_informations;
    return fetcher(`${BASE_URL_API}/onboarding/user/create/${id_user}`, {
        method: "PATCH",
        body: JSON.stringify({
            step: "set_contract",
            email,
            ...data,
        }),
        credentials: "include",
    });
};

export const _api_save_resources = ({ resources }) => {
    const { email, id_user } = useStepper.getState().step_personal_informations;
    return fetcher(`${BASE_URL_API}/onboarding/user/create/${id_user}`, {
        method: "PATCH",
        body: JSON.stringify({
            step: "set_resources",
            email,
            resources,
        }),
        credentials: "include",
    });
};

export const _api_save_step_roles = ({ roles }) => {
    const { email, id_user } = useStepper.getState().step_personal_informations;
    return fetcher(`${BASE_URL_API}/onboarding/user/create/${id_user}`, {
        method: "PATCH",
        body: JSON.stringify({
            step: "set_account_params",
            email,
            role_codes: roles,
        }),
        credentials: "include",
    });
};

export const _api_patch_assign_task = ({ id_user, email, tasks }) => {
    return fetcher(`${BASE_URL_API}/onboarding/user/create/${id_user}`, {
        method: "PATCH",
        body: JSON.stringify({
            step: "set_onboarding_tasks",
            email,
            tasks,
        }), // The data
        credentials: "include",
    });
};

export const _api_save_steps = ({ id_user, email }) => {
    return fetcher(`${BASE_URL_API}/onboarding/user/create/${id_user}`, {
        method: "PUT",
        body: JSON.stringify({
            email,
        }), // The data
        credentials: "include",
    });
};
